<template>
    <div>
        <div class="mem_filter">
            <ul class="mem_menu">
                <li @click="setFilterFunc('ac','')"><a class="mem_a" :class="{'active' : checkSi('')}">전체</a></li>
                <li v-for="(item) in areaList" :key="item.ac_idx" @click="setFilterFunc('ac',item.ac_idx)">
                    <a class="mem_a" :class="{'active' : checkSi(item.ac_idx ) }">{{item.is_city_name}}</a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import memberUtil from "@/components/member/memberUtil";
    import util from "@/mixins/util";

    const {filterConfig} = memberUtil;

    export default {
        name: "MemberFilterDefaultLayout",
        mixins: [memberUtil],
        components: {},
        inject: ['setPage', 'memberListSetData', 'setFilter'],
        props: {
            filterData: {
                default: {}
            },
            areaList: {
                type: Array,
                default: () => {
                    return []
                }
            },
        },
        data() {
            return {
                filterSi:''
            }
        },
        beforeRouterEnter() {
        },
        created() {
        },
        mounted() {

        },
        beforeDestroy() {
        },
        destroyed() {
        },
        computed: {},
        methods: {
            setFilterFunc(key, value) {
                let classname = filterConfig[key].classname;
                if (!classname) {
                    return;
                }
                this[classname] = value;
                this.memberListSetData(classname, value);
                this.setFilter(key, value);
            },
            checkSi(v = '') {
               return v === this.filterSi
            }
        },
        watch: {},
    }
</script>

<style scoped>

</style>